/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { ZoneGeographiqueDto } from '../models/zone-geographique-dto';


/**
 * Fonctions de gestion des zones géographiques
 */
@Injectable({
  providedIn: 'root',
})
export class ZonesGeographiquesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation zoneGeographiqueGetList
   */
  static readonly ZoneGeographiqueGetListPath = '/api/zones-geographiques/list';

  /**
   * Renvoie la liste des zones géographiques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zoneGeographiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  zoneGeographiqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ZoneGeographiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ZonesGeographiquesService.ZoneGeographiqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ZoneGeographiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des zones géographiques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `zoneGeographiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zoneGeographiqueGetList(params?: {
  }): Observable<Array<ZoneGeographiqueDto>> {

    return this.zoneGeographiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ZoneGeographiqueDto>>) => r.body as Array<ZoneGeographiqueDto>)
    );
  }

  /**
   * Path part for operation zoneGeographiqueLoadList
   */
  static readonly ZoneGeographiqueLoadListPath = '/api/zones-geographiques/load-list';

  /**
   * Renvoie la liste des zones géographiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zoneGeographiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ZonesGeographiquesService.ZoneGeographiqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des zones géographiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `zoneGeographiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.zoneGeographiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation zoneGeographiqueGet
   */
  static readonly ZoneGeographiqueGetPath = '/api/zones-geographiques/{id}';

  /**
   * Renvoie la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zoneGeographiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  zoneGeographiqueGet$Response(params: {

    /**
     * Identifiant de la zone géographique
     */
    id: number;
  }): Observable<StrictHttpResponse<ZoneGeographiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, ZonesGeographiquesService.ZoneGeographiqueGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ZoneGeographiqueDto>;
      })
    );
  }

  /**
   * Renvoie la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `zoneGeographiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zoneGeographiqueGet(params: {

    /**
     * Identifiant de la zone géographique
     */
    id: number;
  }): Observable<ZoneGeographiqueDto> {

    return this.zoneGeographiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<ZoneGeographiqueDto>) => r.body as ZoneGeographiqueDto)
    );
  }

  /**
   * Path part for operation zoneGeographiquePut
   */
  static readonly ZoneGeographiquePutPath = '/api/zones-geographiques/{id}';

  /**
   * Met à jour la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zoneGeographiquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiquePut$Response(params: {

    /**
     * Identifiant de la zone géographique à mettre à jour
     */
    id: number;

    /**
     * Zone géographique
     */
    body: ZoneGeographiqueDto
  }): Observable<StrictHttpResponse<ZoneGeographiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, ZonesGeographiquesService.ZoneGeographiquePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ZoneGeographiqueDto>;
      })
    );
  }

  /**
   * Met à jour la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `zoneGeographiquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiquePut(params: {

    /**
     * Identifiant de la zone géographique à mettre à jour
     */
    id: number;

    /**
     * Zone géographique
     */
    body: ZoneGeographiqueDto
  }): Observable<ZoneGeographiqueDto> {

    return this.zoneGeographiquePut$Response(params).pipe(
      map((r: StrictHttpResponse<ZoneGeographiqueDto>) => r.body as ZoneGeographiqueDto)
    );
  }

  /**
   * Path part for operation zoneGeographiqueDelete
   */
  static readonly ZoneGeographiqueDeletePath = '/api/zones-geographiques/{id}';

  /**
   * Supprime la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zoneGeographiqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  zoneGeographiqueDelete$Response(params: {

    /**
     * Identifiant de la zone géographique à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ZonesGeographiquesService.ZoneGeographiqueDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `zoneGeographiqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zoneGeographiqueDelete(params: {

    /**
     * Identifiant de la zone géographique à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.zoneGeographiqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation zoneGeographiquePost
   */
  static readonly ZoneGeographiquePostPath = '/api/zones-geographiques';

  /**
   * Crée la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zoneGeographiquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiquePost$Response(params: {

    /**
     * Zone géographique
     */
    body: ZoneGeographiqueDto
  }): Observable<StrictHttpResponse<ZoneGeographiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, ZonesGeographiquesService.ZoneGeographiquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ZoneGeographiqueDto>;
      })
    );
  }

  /**
   * Crée la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `zoneGeographiquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiquePost(params: {

    /**
     * Zone géographique
     */
    body: ZoneGeographiqueDto
  }): Observable<ZoneGeographiqueDto> {

    return this.zoneGeographiquePost$Response(params).pipe(
      map((r: StrictHttpResponse<ZoneGeographiqueDto>) => r.body as ZoneGeographiqueDto)
    );
  }

  /**
   * Path part for operation zoneGeographiqueDesactivate
   */
  static readonly ZoneGeographiqueDesactivatePath = '/api/zones-geographiques/{id}/desactivate';

  /**
   * Désactive la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zoneGeographiqueDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiqueDesactivate$Response(params: {

    /**
     * Identifiant de la zone géographique à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ZoneGeographiqueDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ZonesGeographiquesService.ZoneGeographiqueDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive la zone géographique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `zoneGeographiqueDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zoneGeographiqueDesactivate(params: {

    /**
     * Identifiant de la zone géographique à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ZoneGeographiqueDto
  }): Observable<number> {

    return this.zoneGeographiqueDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
